import Vue from 'vue'
import Vuex from 'vuex'
import Config from '@/conf'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

const store = new Vuex.Store({
    strict: true,
    state: {
        user: null, // {username,name,apps,auth,cloud}
        app: "",
        conf: null, // 项目配置
        queryUserHistory: JSON.parse(localStorage.getItem("queryUserHistory")),
        frontendVersion: localStorage.getItem('frontendVersion'),
    },
    // 修改全局变量必须通过mutations中的方法
    // mutations只能采用同步方法
    mutations: {
        login(state, user) {
            state.user = user
        },

        logout(state) {
            state.user = null
        },

        changeApp(state, app) {
            // console.log("onAppChange Before:%s After:%s",state.app,app);
            state.app = app
            document.title = '运营工具 - ' + state.app
            state.conf = Config[app]
        },

        saveUserHistory(state, info) {
            let {app, type, userId} = info
            let key = app + '-' + type
            if (!state.queryUserHistory) {
                state.queryUserHistory = {}
            }
            if (!state.queryUserHistory[key] || !Array.isArray(state.queryUserHistory[key])) {
                state.queryUserHistory[key] = [{value: userId}]
                localStorage.setItem("queryUserHistory", JSON.stringify(state.queryUserHistory));
                return
            }
            // 进到这里，说明state.queryUserHistory[key]一定是array，先进行判重
            const result = state.queryUserHistory[key].find(element => {
                return element.value === userId;
            });
            // 检测到重复，直接return不处理
            if (typeof result !== "undefined") {
                return;
            }
            if (state.queryUserHistory[key].length >= 10) {
                state.queryUserHistory[key].shift()
            }
            state.queryUserHistory[key].push({value: userId})
            localStorage.setItem("queryUserHistory", JSON.stringify(state.queryUserHistory));
        },
        setFrontendVersion(state, payload) {
            state.frontendVersion = payload.version;
            localStorage.setItem("frontendVersion", state.frontendVersion);
        },
    },
    // 异步方法用actions
    // actions不能直接修改全局变量，需要调用commit方法来触发mutation中的方法
    actions: {
    },
    plugins: [createPersistedState()],
})

export default store
